import { translate, TranslationKeyEn } from './translate.helper';

const ORDER_SOURCE_TRANSLATION_KEYS: Partial<Record<string, TranslationKeyEn>> = {
    MAERSK_INTEGRATION: 'order.source.maerskIntegration',
    PUBLIC_API: 'order.source.publicApi',
    VESSEL_REQUISITION: 'order.source.vesselRequisition',
    MARI_APPS: 'order.source.mariApps',
    CLOUD_FLEET_MANAGER_INTEGRATION: 'order.source.cloudFleetManagerIntegration',
    BASS_NET_INTEGRATION: 'order.source.bassNetIntegration',
};

export const getOrderSourceHumanReadableValue = (source?: string): string | null => {
    if (!source) {
        return null;
    }

    const translationKey = ORDER_SOURCE_TRANSLATION_KEYS[source];

    return translationKey ? translate(translationKey) : null;
};
